/* Font awesome icon library import */
import { library } from '@fortawesome/fontawesome-svg-core'

/* solid */
import { faMapMarker } from '@fortawesome/free-solid-svg-icons/faMapMarker'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons/faLightbulb'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt'
import { faPaperclip } from '@fortawesome/free-solid-svg-icons/faPaperclip'
import { faEuroSign } from '@fortawesome/free-solid-svg-icons/faEuroSign'
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons/faMinusCircle'
import { faPen } from '@fortawesome/free-solid-svg-icons/faPen'
import { faImage } from '@fortawesome/free-solid-svg-icons/faImage'
import { faCamera } from '@fortawesome/free-solid-svg-icons/faCamera'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import { faGasPump } from '@fortawesome/free-solid-svg-icons/faGasPump'
import { faTag } from '@fortawesome/free-solid-svg-icons/faTag'
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar'
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser'
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock'
import { faShareAlt } from '@fortawesome/free-solid-svg-icons/faShareAlt'
import { faSlidersH } from '@fortawesome/free-solid-svg-icons/faSlidersH'

/* regular / far */
import { faComment } from '@fortawesome/free-regular-svg-icons/faComment'
import { faClock } from '@fortawesome/free-regular-svg-icons/faClock'

/* pro solid / fas */
import { faFileCheck } from '@fortawesome/pro-solid-svg-icons/faFileCheck'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { faHandshakeAlt } from '@fortawesome/pro-solid-svg-icons/faHandshakeAlt'
import { faEnvelope as fasEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope'
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell'
import { faBells } from '@fortawesome/pro-solid-svg-icons/faBells'
import { faFileSignature } from '@fortawesome/pro-solid-svg-icons/faFileSignature'

/* pro regular / far */
import { faTachometerFast } from '@fortawesome/pro-regular-svg-icons/faTachometerFast'
import { faCog } from '@fortawesome/pro-regular-svg-icons/faCog'
import { faEllipsisH } from '@fortawesome/pro-regular-svg-icons/faEllipsisH'
import { faCropAlt } from '@fortawesome/pro-regular-svg-icons/faCropAlt'
import { faExpandArrowsAlt } from '@fortawesome/pro-regular-svg-icons/faExpandArrowsAlt'
import { faExternalLinkAlt } from '@fortawesome/pro-regular-svg-icons/faExternalLinkAlt'
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight'
import { faSlidersH as farSlidersH } from '@fortawesome/pro-regular-svg-icons/faSlidersH'
import { faEuroSign as faProRegularEuroSign } from '@fortawesome/pro-regular-svg-icons/faEuroSign'

/* pro light / fal */
import { faFileAlt } from '@fortawesome/pro-light-svg-icons/faFileAlt'
import { faSignature } from '@fortawesome/pro-light-svg-icons/faSignature'
import { faEuroSign as faLightEuroSign } from '@fortawesome/pro-light-svg-icons/faEuroSign'
import { faCarSide } from '@fortawesome/pro-light-svg-icons/faCarSide'
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck'
import { faBook } from '@fortawesome/pro-light-svg-icons/faBook'
import { faPaperclip as falPaperclip } from '@fortawesome/pro-light-svg-icons/faPaperclip'
import { faTimes as falTimes } from '@fortawesome/pro-light-svg-icons/faTimes'
import { faCar } from '@fortawesome/pro-light-svg-icons/faCar'
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight'
import { faSearchPlus } from '@fortawesome/pro-light-svg-icons/faSearchPlus'
import { faSearchMinus } from '@fortawesome/pro-light-svg-icons/faSearchMinus'

/* pro duotone / fad */
import { faUserFriends } from '@fortawesome/pro-duotone-svg-icons/faUserFriends'

library.add(
    faMapMarker,
    faMapMarkerAlt,
    faSearch,
    faTimes,
    falTimes,
    faCheck,
    faWrench,
    faLightbulb,
    faExclamationCircle,
    faCalendarAlt,
    faPaperclip,
    falPaperclip,
    faFileCheck,
    faEuroSign,
    faTachometerFast,
    faComment,
    faClock,
    faMinusCircle,
    faCog,
    faPen,
    faImage,
    faCamera,
    faTrashAlt,
    faCheckCircle,
    faPlus,
    faEllipsisH,
    faFileAlt,
    faSignature,
    faLightEuroSign,
    faCarSide,
    faShieldCheck,
    faBook,
    faHandshakeAlt,
    faGasPump,
    faTag,
    faStar,
    faUserFriends,
    faUser,
    faLock,
    fasEnvelope,
    faCropAlt,
    faCar,
    faExpandArrowsAlt,
    faChevronLeft,
    faChevronRight,
    faExternalLinkAlt,
    faShareAlt,
    faAngleRight,
    faSlidersH,
    farSlidersH,
    faProRegularEuroSign,
    faBell,
    faBells,
    faSearchPlus,
    faSearchMinus,
    faFileSignature
)
